import {BaseInfo, UserGlobalInfo} from "@/Core/Login/types/user";
import UserGlobalMgr from "@/Core/UserGlobalMgr";
import SdkTrack from "@/Fwk/Kit/SdkTrack";
import {getUserInfo} from "@/app/userSliceUtil";
import {UserInfoState} from "@/app/userSlice";

export default class TrackBase {
    static tag = `[EventTrack]`;

    static T513(name: string, value1?: string, value2?: string, keyValues?: [string, string][]) {
        SdkTrack.track513Commit(name, value1, value2, new Map(keyValues));
    }

    static T512(name: string, value1?: string, value2?: string, keyValues?: [string, string][]) {
        SdkTrack.track512Commit(name, value1, value2, new Map(keyValues));
    }

    // protected static get userBaseInfo(): BaseInfo {
    //     return UserGlobalMgr.getTempUserBaseInfo;
    // }

    protected static async userInfo(): Promise<UserInfoState> {
        return await getUserInfo();
    }

}